import React from 'react'
import {
  CFImage,
  CFLink,
  CFView,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { facebook, yelp, zomato, instagram } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView mv="20px" column justifyStart>
          <CFView h3 futura bold color="#D72D2D" mb="20px">
            SOCIAL MEDIA
          </CFView>
          <CFView row center black bold>
            <CFLink
              target="_blank"
              href="https://www.facebook.com/WEGRILLPOCO/"
            >
              <CFImage
                w="45px"
                pr="10px"
                src={facebook}
                alt="We Grill Facebook"
              />
            </CFLink>
            <CFLink
              target="_blank"
              href="https://www.instagram.com/we_grill_poco/"
            >
              <CFImage
                w="45px"
                pr="10px"
                src={instagram}
                alt="We Grill Facebook"
              />
            </CFLink>
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView mb="13px" mt="15px" column justifyStart>
          <CFView h3 futura bold color="#D72D2D" mb="15px">
            SOCIAL MEDIA
          </CFView>
          <CFView row justifyStart alignCenter black bold>
            <CFLink
              target="_blank"
              href="https://www.facebook.com/WEGRILLPOCO/"
            >
              <CFImage
                w="45px"
                pr="10px"
                src={facebook}
                alt="We Grill Facebook"
              />
            </CFLink>
            <CFLink
              target="_blank"
              href="https://www.instagram.com/we_grill_poco/"
            >
              <CFImage
                w="45px"
                pr="10px"
                src={instagram}
                alt="We Grill Facebook"
              />
            </CFLink>
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
